import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage overline="Documento legal" title="Política de Privacidade">
      <p>
        A presente Política de Privacidade descreve como o serviço Sua Piscina PT recolhe, utiliza e protege os dados pessoais dos proprietários que pedem uma simulação visual do seu jardim. Cumprimos integralmente o Regulamento Geral de Proteção de Dados (RGPD) e a legislação portuguesa aplicável.
      </p>

      <h2>Responsável pelo tratamento</h2>
      <p>
        O responsável pelo tratamento dos dados recolhidos através do formulário em suapiscinapt.com é o serviço Sua Piscina PT, operado por [nome/entidade a indicar]. Para qualquer questão relativa a privacidade, contacte hello@suapiscinapt.com.
      </p>

      <h2>Dados recolhidos</h2>
      <p>
        Recolhemos apenas os dados estritamente necessários para preparar a simulação e contactar o proprietário: nome, telefone, email, zona, prazo previsto, intenção, eventuais notas e fotografia do jardim.
      </p>

      <h2>Finalidade do tratamento</h2>
      <p>
        Os dados são utilizados para preparar e enviar a simulação visual, comunicar a estimativa de investimento e, caso o proprietário manifeste interesse em avançar, encaminhar o contacto para um instalador parceiro acreditado da sua zona.
      </p>

      <h2>Partilha com terceiros</h2>
      <p>
        Os dados não são partilhados com terceiros sem autorização expressa do proprietário. Apenas quando o próprio manifesta interesse em receber um orçamento é que partilhamos o contacto com o instalador parceiro adequado à zona indicada. Os dados podem ainda ser processados por fornecedores técnicos de alojamento, base de dados e infraestrutura de site que utilizamos na operação do serviço, os quais apenas actuam sob as nossas instruções.
      </p>

      <h2>Conservação dos dados</h2>
      <p>
        Os dados são conservados durante o tempo necessário para a prestação do serviço e até 12 meses após o último contacto, salvo obrigação legal em contrário ou pedido de apagamento antes desse prazo.
      </p>

      <h2>Direitos do titular</h2>
      <p>
        O proprietário pode, a qualquer momento, exercer os direitos de acesso, retificação, apagamento, limitação, portabilidade e oposição ao tratamento. Basta enviar um email para hello@suapiscinapt.com.
      </p>
    </LegalPage>
  );
}
